// removed by extract-text-webpack-plugin
module.exports = {"FormInner":"FormSMS__FormInner___14m0I","Title":"FormSMS__Title___39Duf","Description":"FormSMS__Description___26DZx","LabelErr":"FormSMS__LabelErr___1T7Kw","InputWrap":"FormSMS__InputWrap___3JnPU","Input":"FormSMS__Input___VbDLO","Mask":"FormSMS__Mask___RUKcS","InputError":"FormSMS__InputError___2NwoR","AwaitSMS":"FormSMS__AwaitSMS___wBFiq","Blue":"FormSMS__Blue___1Netf","SubmitButton":"FormSMS__SubmitButton___1K5l4","LoaderWrapper":"FormSMS__LoaderWrapper___28jJU","Loader":"FormSMS__Loader___3JnSR","loader10":"FormSMS__loader10___3E5OA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/FormSMS/FormSMS.scss
// module id = 1361
// module chunks = 0